import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useToast } from '@/components/ui'
import { videosService } from '@/services/http/videosService'

export const useGetAllUserVideos = () => {
  const { toast } = useToast()

  const { data, isError, isLoading, refetch } = useQuery({
    queryKey: ['useGetAllUserVideos'],
    queryFn: () => videosService.getAllUserVideos(),
  })

  useEffect(() => {
    if (isError)
      toast({
        title: 'Erro ao carregar dados da trilha de conhecimento',
        variant: 'destructive',
      })
  }, [isError, toast])

  if (data) {
    const { knowledgeTrail } = data
    return {
      knowledgeTrail,
      isLoading,
      refetchGetAllUserVideos: refetch,
    }
  }

  return {
    knowledgeTrail: [],
    isLoading,
    refetchGetAllUserVideos: refetch,
  }
}
